export interface ITrackingSource {
  type: string
  value: string
}

export type TShipmentsInput = {
  filters?: { [key: string]: string }
  hideNeedsCarrierShipments?: boolean
  paginationInput?: PaginationData
  tab?: 'Active' | 'Closed'
}

type TLocationInput = {
  latitude: number
  longitude: number
}
export type TGetShipmentsInput = {
  customerName?: string
  destinationAppointment?: AppointmentOptionsEnum
  destinationLocation?: TLocationInput
  destinationSearchRadius?: number
  originAppointment?: AppointmentOptionsEnum
  originLocation?: TLocationInput
  originSearchRadius?: number
  page: number
  paginationKey: string | null
  shipmentNumber?: string
  shipmentStatus: string[]
  sort?: ShipmentSortEnum
  teamMemberIDs?: string[]
  timezone?: string
  trackingStatus?: ShipmentTrackingStatusEnum
}

export enum TShipmentStatus {
  Canceled = 'Canceled', // adding for backwards compatibility
  CarrierAssigned = 'Carrier assigned',
  Completed = 'Completed',
  Delivered = 'Delivered',
  Expired = 'Expired',
  // adding for backwards compatibility
  InTransit = 'In transit',
  NeedsCarrier = 'Needs carrier',

  Pending = 'Pending'
}

export enum StopStatus {
  Arrived = 'Arrived',
  Departed = 'Departed',
  Enroute = 'En route'
}

export enum TShipmentTab {
  Active = 'Active',
  Closed = 'Closed'
}

export enum TShipmentMode {
  FTL = 'FTL',
  LTL = 'LTL',
  Ocean = 'Ocean'
}

export interface PaginationData {
  shipmentID: string | null
  timestamp: string | null
  userOrWorkspaceID: string | null
}

export interface IShipmentsPaginationData {
  dataSource?: 'CACHE' | 'DATABASE'
  hasNextPage: boolean
  paginationKey: string | null
}

export enum ShipmentSortEnum {
  DROPOFF = 'DROPOFF',
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  PICKUP = 'PICKUP'
}

/**
 * The enum to filter by isTracking
 */
export enum ShipmentTrackingStatusEnum {
  NOT_TRACKING = 'NOT_TRACKING',
  TRACKING = 'TRACKING'
}

/**
 * The enum for tracking sources
 */
export enum ShipmentTrackingSourceEnum {
  API = 'API',
  DRIVER_MOBILE_APP = 'DRIVER_MOBILE_APP',
  ELD = 'ELD',
  EXTERNAL_TRACKING_LINK = 'EXTERNAL_TRACKING_LINK',
  SFTP = 'SFTP',
  TIVE_DEVICE = 'TIVE_DEVICE',
  TMS_APP = 'TMS_APP',
  VISIBILITY_PROVIDER = 'VISIBILITY_PROVIDER'
}

/**
 * The source of the tracking data (e.g. 'Mobile App', 'ELD' etc.)
 */
export enum ShipmentTrackingSourceForReportsEnum {
  API = 'API',
  CSVFile = 'CSV File',
  Convoy = 'Convoy',
  EDIFile = 'EDI File',
  ELD = 'ELD',
  ExternalTrackingLink = 'External Tracking Link',
  MobileApp = 'Mobile App',
  TMSApp = 'TMS App',
  ThirdPartyCarrierTrackingAPI = 'Third Party Carrier Tracking API',
  TiveDevice = 'Tive Device',
  TrailerNumber = 'Trailer Number',
  TruckNumber = 'Truck Number',
  VisibilityProvider = 'Visibility Provider'
}

export type TSortItemOption = {
  key: string
  value: ShipmentSortEnum.DROPOFF | ShipmentSortEnum.NEWEST | ShipmentSortEnum.OLDEST | ShipmentSortEnum.PICKUP
}

export enum AppointmentOptionsEnum {
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  WITHIN_NEXT_WEEK = 'WITHIN_NEXT_WEEK'
}

export type TAppointmentOptions =
  | AppointmentOptionsEnum.TODAY
  | AppointmentOptionsEnum.TOMORROW
  | AppointmentOptionsEnum.WITHIN_NEXT_WEEK
